// src/data.ts
import { Project } from "./types";

export const projects: Project[] = [

   {
      id: "roadtripScrapbook",
      status: "Complete",
      title: "The Road Less Boring",
      subtitle: "React (Vite), React-Leaflet, PHP REST API, MySQL",
      description:
        "An interactive React-powered scrapbook that brings locations to life. Sign the wall, browse photo vignettes, explore supplemental images, and leave comments to engage with each location.",
      image: "/project-images/leaflet.jpg",
      link: "/projects/theroadlessboring",
      external: true,
    },
   {
      id: "cinemaUndercover",
      status: "Complete",
      title: "Cinema Undercover",
      subtitle: "React, TMDB API",
      description:
        "This started as a small Tic-Tac-Toe game, which I'd built using a React-tutorial. I evolved it into a guessing game where players uncover tiles to slowly reveal a hidden movie poster or actor. The challenge: identify the film/actor using the fewest tile reveals.",
      image: "/project-images/cinemaUndercover.png",
      link: "/projects/cinemaUndercover",
      repo: "https://github.com/you/movieposterguess",
      external: true,
    },
     {
      id: "github-sampler",
      status: "Complete",
      title: "My Github Portfolio",
      subtitle: "React app powered by GitHub API",
      description:
        "A React-based portfolio app that fetches and displays the README files from a sampling of my GitHub repositories. Explore some of my completed past projects with live previews of documentation and project details, all dynamically loaded using the GitHub API.",
      image: "/project-images/github-sampler.png",
      link: "/projects/github-sampler",
      repo:"",
      external: true,
    },
    {
      id: "accidentalShakespeare",
      status: "Complete",
      title: "Accidental Shakespeare Theater Company",
      subtitle: "Ruby, Jekyll, Liquid",
      description:
        "This was my first real client project, created during the The Nerdery's 2017 Overnight Website Challenge. I worked as part of a 12-person team over 24 hours to design and build a website for a nonprofit organization. My primary contribution was developing the “Past Productions” section and the individual production detail pages.",
      image: "/project-images/AccidentalShakespeare.png",
      link: "https://accidentalshakespeare.org/about/past-productions/",
      repo: "https://github.com/hollabaq86/company-site",
      external: true,
    },
    {
      id: "shelfSpace",
      status: "Coming Soon", 
      title: "ShelfSpace",
      subtitle: "React, TypeScript, Google Books API, Styled Components, Jest",
      description:
        "Log your books and track pages read each year, with a visual interactive bookshelf.",
      image: "./project-4.gif",
      link: "/wormHole",
      external: false,
    },
    {
      id: "journeyBoard",
      status: "Coming Soon", 
      title: "Journey Board",
      subtitle: "React, NextJS, Tailwind CSS, ESLint, App Router, TypeScript, Google Maps API, PHP REST API, MySQL",
      description:
        "A travel itinerary planner for organizing multi-day road trips with mapped stops, schedules, distance tracking, and cost summaries.",
      image: "/project-images/theroad.png",
      link: "/wormHole",
      external: false,
    },
  ];



  export const academics = [
    {
      title: "React Reserve",
      subtitle: "MERN Stack",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-1.gif",
      link: "https://reactbootcamp.com",
    },
    {
      title: "React Tracks",
      subtitle: "React and Python",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-2.gif",
      link: "https://reedbarger.com",
    },
    {
      title: "DevChat",
      subtitle: "React and Firebase",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
      image: "./project-3.gif",
      link: "https://jsbootcamp.com",
    },
    {
      title: "Haikuna-Matata (Group Project)",
      subtitle: "Python",
      description:
        "Haikuna-Matata generates completely original, correctly formatted haiku based on user input. A user types a word into the console when running the program, and the program will return a 5/7/5 style haiku built around the user's input. Given no user input, the haiku generated will be centered around a randomly generated word or pair of words. Users are then asked to rate the coherence of each line of the haiku. If a line is up-voted, the frequency of those word pairings will increase in the database. If a line is down-voted, the frequency of those word pairings will decrease in the database. Over time, this will train the generator to create more coherent haiku.",
      image: "https://cloud.githubusercontent.com/assets/19498387/23668761/a18b77ca-0327-11e7-8df1-d7bb99bbc37d.png",
      link: "https://github.com/jepetersohn/haikuna-matata",
    },
  ];